import React from 'react';
import { TopToolbar, CreateButton, usePermissions, useResourceDefinition, useTranslate } from 'react-admin';
import { useLocation } from 'react-router-dom';
import CustomExportButton from '@/components/global/buttons/CustomExportButton.jsx';
import CustomCreateButton from '@/components/global/buttons/CustomCreateButton';
import CustomToolbarActionsPopover from '@/components/global/buttons/CustomToolbarActionsPopover';
import { CustomSelectColumnsButton } from '@/components/global/buttons/CustomSelectColumnsButton.jsx';
import ColumnsIcon from '@/assets/icons/columns-icon.svg?react';
import { SearchFilterInput } from '@/components/global/filters/SearchFilterInput';
import CustomFilterButton from '@/components/global/filters/CustomFilterButton';

const CustomActions = () => {
    const { permissions } = usePermissions();
    const { hasCreate } = useResourceDefinition();
    const location = useLocation();
    const translate = useTranslate();

    const renderButtons = () => {
        if (location.pathname === '/tag-category' && hasCreate && (permissions.isAdmin || permissions.isServiceMaster || permissions.isClientMaster)) {
            return <CustomCreateButton label={translate('common.addNewCategory')} />;
        } else if (location.pathname.startsWith('/analytic')) {
            return null;
        } else {
            return (
                <CustomToolbarActionsPopover>
                    {(permissions.isAdmin || permissions.isServiceMaster || permissions.isClientMaster) && hasCreate ? <CreateButton /> : null}
                    <CustomExportButton />
                </CustomToolbarActionsPopover>
            );
        }
    };

    const pathClass = `toolbar--${location.pathname.replaceAll('/', '-').substring(1)}`;
    const hasGrid = location.pathname !== '/tag-category' && !location.pathname.startsWith('/analytic');

    return (
        <TopToolbar className={pathClass}>
            {hasGrid && <SearchFilterInput />}
            <CustomFilterButton />
            {hasGrid && <CustomSelectColumnsButton startIcon={<ColumnsIcon />} style={{ margin: '0px -4px' }} />}
            {renderButtons()}
        </TopToolbar>
    );
};

export default CustomActions;
